import { useUserStore } from "~/stores/userStore"

export default defineNuxtRouteMiddleware(async (_to, _from) => {
  const userStore = useUserStore()
  // Deep links land here before the user is known; shares the in-flight refresh.
  await userStore.asyncReloadOnce()

  if (userStore.isTeacherType) {
    return navigateTo("/parskats")
  }
})
